import { useProfile } from '@/api/profile'
import { useCompany, PLAN_FEATURE_MIN, type PlanFeature } from '@/api/company'

/**
 * Ce que le plan de l'entreprise permet. Le serveur est la source de vérité
 * (403 `plan_required`) ; ici on ne fait que griser les boutons à l'avance.
 * Tant que la fiche n'est pas chargée, tout est considéré permis (pas de
 * clignotement de verrou).
 */
export function usePlanRights() {
  const { data: profile } = useProfile()
  const { data: company } = useCompany(profile?.company ?? undefined)
  const rights = company?.plan_rights
  const allowed = (feature: PlanFeature): boolean => rights?.[feature] ?? true
  const planFor = (feature: PlanFeature) => PLAN_FEATURE_MIN[feature]
  return { allowed, planFor, loaded: !!company }
}
